import styled from 'styled-components';

import { Box } from '@/shared/ui/box';

export const Wrapper = styled(Box)`
	min-height: calc(100vh - ${({ theme: { layouts } }) => layouts.header.height});
`;
